import {useVideoPlayer} from '../../useVideoPlayer';
import {VideoControlsItem} from '../Item/VideoControlsItem';

import {Icon} from '@components/@icons';
export const VideoSkipButton = () => {
    const {seekBack, seekForward} = useVideoPlayer();
    return (
        <>
            <VideoControlsItem onClick={seekBack}>
                <Icon name="10-back" />
            </VideoControlsItem>
            <VideoControlsItem onClick={seekForward}>
                <Icon name="10-forward" />
            </VideoControlsItem>
        </>
    );
};
